const swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // when window width is >= ...
    breakpoints: {
        640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        768: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
    },
});

window.students = () => {
    return {
        view: 'slider',
        init() {
            const gridViewEl = document.querySelector('#students-grid-view');

            const slides = document
                .querySelectorAll('.swiper-slide')
                .forEach((el) => {
                    const newEl = el.cloneNode(true);

                    newEl.classList.remove('h-full', 'swiper-slide');

                    newEl.style.cssText = '';

                    gridViewEl.appendChild(newEl);
                });

            const swiperEl = document.querySelector('.swiper-wrapper');

            for (let i = swiperEl.children.length; i >= 0; i--) {
                swiperEl.appendChild(
                    swiperEl.children[(Math.random() * i) | 0],
                );
            }

            document
                .querySelector('.swiper-container')
                .classList.remove('invisible');

            window.emitter.on('set-student-view', (newView) => {
                this.view = newView;
            });
        },
        toggleView() {
            this.view = this.view === 'slider' ? 'grid' : 'slider';
        },
    };
};
